import { Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { TimeSelect } from "@/components/ui/time-select";

interface TimeRangeSelectorProps {
  startTime: string;
  endTime: string;
  onStartTimeChange: (time: string) => void;
  onEndTimeChange: (time: string) => void;
  className?: string;
}

export function TimeRangeSelector({
  startTime,
  endTime,
  onStartTimeChange,
  onEndTimeChange,
  className,
}: TimeRangeSelectorProps) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;

  return (
    <div className={cn("flex items-center gap-2 text-sm", className)}>
      <Clock className="h-4 w-4 text-black flex-shrink-0" />
      <span className="font-medium text-black flex-shrink-0">
        {t("booking.shows.filters.timeRangeLabel")}
      </span>

      <div className="flex items-center gap-2">
        <TimeSelect
          value={startTime}
          onChange={onStartTimeChange}
          max={endTime}
          interval={30}
          locale={locale}
          className="w-[120px] border-2 border-purple-900"
        />

        <span className="font-medium text-black">
          {t("booking.shows.filters.to")}
        </span>

        <TimeSelect
          value={endTime}
          onChange={onEndTimeChange}
          min={startTime}
          interval={30}
          locale={locale}
          className="w-[120px] border-2 border-purple-900"
        />
      </div>
    </div>
  );
}
